<template>
	<div style="overflow: hidden;">
		<transition
			name="fade"
			enter-active-class="animated fadeIn"
			leave-active-class="animated fadeOut"
		>
			<b-container>
				<div
					align-h="between"
					class="d-flex flex-column justify-content-center align-items-center"
					v-if="isSurety && !isSuretyRegistered"
				>
					<h3
						class="text-center"
						v-if="
							routeName == 'firstSuretyIdentityInfo' ||
								routeName == 'SuppliersCustomerEditFirstSuretyIdentityInfo'
						"
					>
						{{ $t("صفحه ثبت ضامن اول") }}
					</h3>
					<h3
						class="text-center"
						v-if="
							routeName == 'secondSuretyIdentityInfo' ||
								routeName == 'SuppliersCustomerEditSecondSuretyIdentityInfo'
						"
					>
						{{ $t("صفحه ثبت ضامن دوم") }}
					</h3>
					<b-col md="6" class="mt-5">
						<b-form-group
							id="melli_code_group"
							:label="$t('register.melliCode')"
							label-for="melli_code"
							label-cols-sm="3"
							class="mb-0"
						>
							<b-form-input
								id="melli_code"
								type="number"
								v-model="$v.form.melli_code.$model"
								aria-describedby="melli_code-live-feedback"
								:state="validateState('melli_code')"
								:readonly="!editable"
							></b-form-input>
							<b-form-invalid-feedback
								id="melli_code-live-feedback"
								v-show="!$v.form.melli_code.required"
							>
								{{ $t("validation.required") }}
							</b-form-invalid-feedback>
							<b-form-invalid-feedback
								id="melli_code-live-feedback"
								v-show="!$v.form.melli_code.checkMelliCode"
							>
								{{ $t("validation.MelliCodeCheck") }}
							</b-form-invalid-feedback>
						</b-form-group>
						<!-- <small class="mt-0" v-if="routeName=='SuppliersCustomerEditSecondSuretyIdentityInfo' &&
									isSupplier">اطلاعات ضامن دوم متقاضی خود را وارد کنید</small>
									<small class="mt-0" v-if="routeName=='SuppliersCustomerEditFirstSuretyIdentityInfo' &&
									isSupplier">اطلاعات ضامن اول متقاضی خود را وارد کنید</small> -->
						<b-button
							type="button"
							size="lg"
							class="btn btn-bg--primary mr-auto ml-auto   col-12  btn-hover--3d mt-3 mb-3"
							@click="sendMelliCode"
							>ارسال کد ملی</b-button
						>
					</b-col>
				</div>

				<div v-else>
					<h3
						v-if="isSurety && routeName == 'firstSuretyIdentityInfo'"
						class="text-center  mb-5 textBlue"
					>
						{{ $t("register.firstSuretyIdentityInfo") }}
					</h3>
					<h3
						v-if="isSurety && routeName == 'secondSuretyIdentityInfo'"
						class="text-center  mb-5 textBlue"
					>
						{{ $t("register.secondSuretyIdentityInfo") }}
					</h3>
					<h3 v-if="!isSurety" class="text-center mt-0  mb-5 textBlue">
						{{ $t("register.identityInfo") }}
					</h3>

					<b-form @submit.stop.prevent="onSubmit">
						<!-- ================================= first_name $ lastName ============================== -->
						<b-row align-h="between">
							<!--------------------------------- first_name -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="first_name_group"
									:label="$t('register.name')"
									label-cols-sm="4"
									label-for="first_name"
								>
									<b-form-input
										id="first_name"
										type="text"
										v-model="$v.form.first_name.$model"
										:state="validateState('first_name')"
										aria-describedby="first_name-live-feedback"
										:readonly="!editable"
									></b-form-input>
									<b-form-invalid-feedback id="first_name-live-feedback">
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
							<!--------------------------------- LastName -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="last_name_group"
									:label="$t('register.lastName')"
									label-for="lastName"
									label-cols-sm="4"
								>
									<b-form-input
										id="last_name"
										v-model="$v.form.last_name.$model"
										:state="validateState('last_name')"
										aria-describedby="last_name-live-feedback"
										:readonly="!editable"
									></b-form-input>
									<b-form-invalid-feedback id="last_name-live-feedback">
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
						</b-row>

						<!-- ================================= fatherName $ gender ============================== -->
						<b-row align-h="between">
							<!--------------------------------- fatherName -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="father_name_group"
									:label="$t('register.fatherName')"
									label-cols-sm="4"
									label-for="father_name"
								>
									<b-form-input
										id="father_name"
										type="text"
										v-model="$v.form.father_name.$model"
										:state="validateState('father_name')"
										aria-describedby="father_name-live-feedback"
										:readonly="!editable"
									></b-form-input>
									<b-form-invalid-feedback id="father_name-live-feedback">
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>

							<!--------------------------------- gender -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="gender_group"
									:label="$t('register.gender')"
									label-for="gender"
									label-cols-sm="4"
									:state="validateState('gender')"
								>
									<b-form-radio-group
										value="m"
										v-model="$v.form.gender.$model"
										:state="validateState('gender')"
										:options="gender_options"
										aria-describedby="gender-live-feedback"
										class="pt-1"
										:disabled="!editable"
									>
										<b-form-invalid-feedback
											id="gender-live-feedback"
											:state="validateState('gender')"
										>
											{{ $t("validation.requiredToFill") }}
										</b-form-invalid-feedback>
									</b-form-radio-group>
								</b-form-group>
							</b-col>
						</b-row>

						<!-- ================================= Education $ birth_date ============================== -->
						<b-row align-h="between">
							<!--------------------------------- Education -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="education_group"
									:label="$t('register.education')"
									label-cols-sm="4"
									label-for="education"
									:state="validateState('education')"
								>
									<b-form-select
										v-model="$v.form.education.$model"
										:options="education_options"
										class="form-control"
										:state="validateState('education')"
										aria-describedby="education-live-feedback"
										:disabled="!editable"
									></b-form-select>
									<b-form-invalid-feedback id="education-live-feedback">
										{{ $t("validation.requiredToFill") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
							<!--------------------------------- birth_date -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="birth_date_group"
									:label="$t('register.birthday')"
									label-for="birth_date"
									label-cols-sm="4"
								>
									<date-picker
										id="birth_date"
										v-model="$v.form.birth_date.$model"
										placeholder="1357/11/22"
										format="YYYY-MM-DD"
										display-format="jYYYY/jMM/jDD"
										min="1951/03/22"
										max="2001/03/21"
										initial-value="1979/02/11"
										:input-class="
											!$v.form.birth_date.required &&
											$v.form.birth_date.$invalid &&
											$v.form.birth_date.$dirty
												? 'form-control border-danger mb-0'
												: 'form-control'
										"
										view="year"
										color="#5c6bc0"
										:disabled="!editable"
									>
										<div slot="label"></div>
									</date-picker>
									<small
										class="text-danger mt-n3"
										v-show="
											!$v.form.birth_date.required &&
												$v.form.birth_date.$invalid &&
												$v.form.birth_date.$dirty
										"
										id="birth_date-live-feedback"
									>
										{{ $t("validation.required") }}
									</small>
								</b-form-group>
							</b-col>
						</b-row>

						<!-- ================================= phoneNumber $ phoneNumberDescription ============================== -->
						<b-row align-h="between">
							<!--------------------------------- phoneNumber -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="phone_number_group"
									type="tel"
									:label="$t('register.phone')"
									label-cols-sm="4"
									label-for="phone_number"
								>
									<b-form-input
										id="phone_number"
										type="text"
										v-model="$v.form.phone_number.$model"
										:state="validateState('phone_number')"
										aria-describedby="phone_number-live-feedback"
										:readonly="!editable"
									></b-form-input>
									<b-form-invalid-feedback
										id="family_mobile_number-live-feedback"
										v-show="!$v.form.phone_number.required"
									>
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
									<b-form-invalid-feedback
										id="family_mobile_number-live-feedback"
										v-show="
											!$v.form.phone_number.minLength |
												!$v.form.phone_number.maxLength
										"
									>
										{{ $t("validation.phoneInvalid") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
							<!--------------------------------- phoneNumberDescription -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="phone_number_des_group"
									:label="$t('register.phoneDes')"
									label-for="phone_number_des"
									:description="$t('register.phoneDescription')"
									label-cols-sm="4"
								>
									<b-form-input
										id="phone_number_des"
										v-model="$v.form.phone_number_description.$model"
										:state="validateState('phone_number_description')"
										aria-describedby="phone_number_des-live-feedback"
										:readonly="!editable"
									></b-form-input>
									<b-form-invalid-feedback id="phone_number_des-live-feedback">
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row align-h="between">
							<!---------------------------------melli_code && mobile_number -----------------------------------------  -->
							<b-col md="6" v-if="isSurety && isSuretyRegistered">
								<b-form-group
									id="melli_code_group"
									:label="$t('register.melliCode')"
									label-for="melli_code"
									label-cols-sm="4"
								>
									<b-form-input
										id="melli_code"
										type="number"
										v-model="$v.form.melli_code.$model"
										aria-describedby="melli_code-live-feedback"
										:state="validateState('melli_code')"
										:readonly="!editable || isSurety"
									></b-form-input>
									<b-form-invalid-feedback
										id="melli_code-live-feedback"
										v-show="!$v.form.melli_code.required"
									>
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
									<b-form-invalid-feedback
										id="melli_code-live-feedback"
										v-show="!$v.form.melli_code.checkMelliCode"
									>
										{{ $t("validation.MelliCodeCheck") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>

							<b-col md="6" v-if="isSurety">
								<b-form-group
									id="mobile_number_group"
									type="tel"
									:label="$t('register.mobileNumber')"
									label-cols-sm="4"
									label-for="mobile_number"
								>
									<b-form-input
										id="mobile_number"
										type="number"
										v-model="$v.form.mobile_number.$model"
										:state="validateState('mobile_number')"
										aria-describedby="mobile_number-live-feedback"
										:readonly="!editable"
									></b-form-input>
									<b-form-invalid-feedback
										id="mobile_number-live-feedback"
										v-show="!$v.form.mobile_number.required"
									>
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
									<b-form-invalid-feedback
										id="mobile_number-live-feedback"
										v-show="
											!$v.form.mobile_number.minLength |
												!$v.form.mobile_number.maxLength
										"
									>
										{{ $t("validation.mobileInvalid") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
						</b-row>

						<!-- ================================= Marital Status ============================== -->
						<b-row align-h="between">
							<!--------------------------------- Marital Status -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="marital_status_group"
									:label="$t('register.maritalStatus')"
									label-for="marital_status"
									label-cols-sm="4"
									:state="validateState('marital_status')"
								>
									<b-form-radio-group
										
										v-model="$v.form.marital_status.$model"
										:state="validateState('marital_status')"
										:options="marital_status_options"
										aria-describedby="marital_status-live-feedback"
										class="pt-1"
										:disabled="!editable"
									>
										<transition name="fade">
											<b-form-radio value="2" v-show="form.gender == 'f'">{{
												$t("register.headOfHousehold")
											}}</b-form-radio>
										</transition>
										<b-form-invalid-feedback
											id="marital_status-live-feedback"
											:state="validateState('marital_status')"
										>
											{{ $t("validation.requiredToFill") }}
										</b-form-invalid-feedback>
									</b-form-radio-group>
								</b-form-group>
							</b-col>
							<b-col md="3"></b-col>
						</b-row>
						<!-- +++++++++++++++++++++++++++++++++++++++++++++++ Famili Information +++++++++++++++++++++++++++++++++++++++++++++++++ -->

						<transition
							name="fadeIn"
							enter-active-class="animated fadeIn"
							leave-active-class="animated fadeOut"
						>
							<section>
								<hr />
								<h3 class="text-center textBlue mb-4">
									{{ $t("register.familiInfo") }}
								</h3>

								<!-- ================================= relational ============================== -->
								<b-row align-h="between">
									<!--------------------------------- famili relational  -----------------------------------------  -->
									<b-col md="6">
										<b-form-group
											id="famili_relational_group"
											:label="$t('register.familiRelational')"
											label-cols-sm="4"
											label-for="famili_relational"
											:state="validateStateFamily('Type')"
											:description="$t('register.familiRelationDesc')"
										>
											<b-form-select
												v-model="$v.form.family.Type.$model"
												:state="validateStateFamily('Type')"
												aria-describedby="famili_relational-live-feedback"
												:disabled="!editable"
											>
												<b-form-select-option :value="0">{{
													$t("register.familiRelation.father")
												}}</b-form-select-option>
												<b-form-select-option :value="1">{{
													$t("register.familiRelation.mother")
												}}</b-form-select-option>
												<b-form-select-option :value="2">{{
													$t("register.familiRelation.brother")
												}}</b-form-select-option>
												<b-form-select-option :value="3">{{
													$t("register.familiRelation.sister")
												}}</b-form-select-option>
												<b-form-select-option
													:value="4"
													v-if="form.marital_status"
													>{{
														$t("register.familiRelation.spouse")
													}}</b-form-select-option
												>
											</b-form-select>
											<b-form-invalid-feedback
												id="famili_relational-live-feedback"
											>
												{{ $t("validation.requiredToFill") }}
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>
									<b-col md="6"></b-col>
								</b-row>

								<!-- ================================= name $ lastName ============================== -->
								<b-row align-h="between">
									<!--------------------------------- Name -----------------------------------------  -->
									<b-col md="6">
										<b-form-group
											id="family_name_group"
											:label="$t('register.name')"
											label-cols-sm="4"
											label-for="family_name"
										>
											<b-form-input
												id="name"
												type="text"
												v-model="$v.form.family.first_name.$model"
												:state="validateStateFamily('first_name')"
												aria-describedby="family_name-live-feedback"
												:readonly="!editable"
											></b-form-input>
											<b-form-invalid-feedback id="family_name-live-feedback">
												{{ $t("validation.required") }}
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>
									<!--------------------------------- LastName -----------------------------------------  -->
									<b-col md="6">
										<b-form-group
											id="family_last_name_group"
											:label="$t('register.lastName')"
											label-for="family_lastName"
											label-cols-sm="4"
										>
											<b-form-input
												id="family_last_name"
												v-model="$v.form.family.last_name.$model"
												:state="validateStateFamily('last_name')"
												aria-describedby="family_last_name-live-feedback"
												:readonly="!editable"
											></b-form-input>
											<b-form-invalid-feedback
												id="family_last_name-live-feedback"
											>
												{{ $t("validation.required") }}
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>
								</b-row>

								<!-- ================================= mobileNumber $ melliCode ============================== -->
								<b-row align-h="between">
									<!--------------------------------- mobileNumber -----------------------------------------  -->
									<b-col md="6">
										<b-form-group
											id="family_mobile_number_group"
											type="tel"
											:label="$t('register.mobileNumber')"
											label-cols-sm="4"
											label-for="family_mobile_number"
										>
											<b-form-input
												id="family_mobile_number"
												type="number"
												v-model="$v.form.family.mobile_number.$model"
												:state="validateStateFamily('mobile_number')"
												aria-describedby="family_mobile_number-live-feedback"
												:readonly="!editable"
												class="form-control form-control-sm"
											></b-form-input>
											<b-form-invalid-feedback
												id="family_mobile_number-live-feedback"
												v-show="!$v.form.family.mobile_number.required"
											>
												{{ $t("validation.required") }}
											</b-form-invalid-feedback>
											<b-form-invalid-feedback
												id="family_mobile_number-live-feedback"
												v-show="
													!$v.form.family.mobile_number.minLength |
														!$v.form.family.mobile_number.maxLength
												"
											>
												{{ $t("validation.mobileInvalid") }}
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>
									<!--------------------------------- melliCode -----------------------------------------  -->
									<b-col md="6">
										<b-form-group
											id="melli_code_group"
											:label="$t('register.melliCode')"
											label-for="melli_code"
											label-cols-sm="4"
										>
											<b-form-input
												id="melli_code"
												type="number"
												v-model="$v.form.family.melli_code.$model"
												aria-describedby="melli_code-live-feedback"
												:state="validateStateFamily('melli_code')"
												:readonly="!editable"
											></b-form-input>
											<b-form-invalid-feedback
												id="melli_code-live-feedback"
												v-show="!$v.form.family.melli_code.required"
											>
												{{ $t("validation.required") }}
											</b-form-invalid-feedback>
											<b-form-invalid-feedback
												id="melli_code-live-feedback"
												v-show="!$v.form.family.melli_code.checkMelliCode"
											>
												{{ $t("validation.MelliCodeCheck") }}
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>
								</b-row>

								<!-- ================================= phoneNumber $ phoneNumberDescription ============================== -->
								<b-row align-h="between">
									<!--------------------------------- phoneNumber -----------------------------------------  -->
									<b-col md="6">
										<b-form-group
											id="family_phone_number_group"
											type="tel"
											:label="$t('register.phone')"
											label-cols-sm="4"
											label-for="family_phone_number"
										>
											<b-form-input
												id="family_phone_number"
												type="text"
												v-model="$v.form.family.phone_number.$model"
												:state="validateStateFamily('phone_number')"
												aria-describedby="family_phone_number-live-feedback"
												:readonly="!editable"
											></b-form-input>
											<b-form-invalid-feedback
												id="family_mobile_number-live-feedback"
												v-show="!$v.form.family.phone_number.required"
											>
												{{ $t("validation.required") }}
											</b-form-invalid-feedback>
											<b-form-invalid-feedback
												id="family_mobile_number-live-feedback"
												v-show="
													!$v.form.family.phone_number.minLength |
														!$v.form.family.phone_number.maxLength
												"
											>
												{{ $t("validation.phoneInvalid") }}
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>
									<!--------------------------------- phoneNumberDescription -----------------------------------------  -->
									<b-col md="6">
										<b-form-group
											id="family_phone_number_des_group"
											:label="$t('register.phoneDes')"
											label-for="family_phone_number_des"
											:description="$t('register.phoneDescription')"
											label-cols-sm="4"
										>
											<b-form-input
												id="family_phone_number_des"
												v-model="$v.form.family.phone_number_description.$model"
												:state="validateStateFamily('phone_number_description')"
												aria-describedby="family_phone_number_des-live-feedback"
												:readonly="!editable"
											></b-form-input>
											<b-form-invalid-feedback
												id="family_phone_number_des-live-feedback"
											>
												{{ $t("validation.required") }}
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>
								</b-row>
							</section>
						</transition>
						<b-row align-h="center" v-show="!edit">
							<b-button
								type="submit"
								size="lg"
								class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
								center
								>{{ $t("register.save") }}</b-button
							>
						</b-row>
						<b-row align-h="center" v-show="edit">
							<b-button
								type="button"
								size="lg"
								class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
								center
								@click.prevent="updateCustomer"
								>{{ $t("register.edit") }}</b-button
							>
						</b-row>
					</b-form>
				</div>
			</b-container>
		</transition>
	</div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import { validationMixin } from "vuelidate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
function checkMelliCode(code) {
	if (
		!/^\d{10}$/.test(code) ||
		code == "0000000000" ||
		code == "1111111111" ||
		code == "2222222222" ||
		code == "3333333333" ||
		code == "4444444444" ||
		code == "5555555555" ||
		code == "6666666666" ||
		code == "7777777777" ||
		code == "8888888888" ||
		code == "9999999999"
	)
		return false;
	var check = parseInt(code[9]);
	var sum = 0;
	var i;
	for (i = 0; i < 9; ++i) {
		sum += parseInt(code[i]) * (10 - i);
	}
	sum %= 11;
	return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
}
export default {
	mixins: [validationMixin],

	data() {
		return {
			isSupplier: false,
			isFirstSupplierSurety: false,
			suretyHaveAlreadyRegistered: false,
			isSurety: false,
			edit: false,
			isSuretyRegistered: false,
			isRegisterCompleted: false,
			form: {
				supplierCustomerId: null,
				first_name: "",
				last_name: null,
				father_name: "",
				gender: "m",
				password: "",
				education: "",
				birth_date: "",
				phone_number: "",
				mobile_number: "",
				phone_number_description: "",
				melli_code: "",
				marital_status: 0,

				family: {
					first_name: "",
					last_name: "",
					Type: "",
					mobile_number: "",
					melli_code: "",
					phone_number: "",
					phone_number_description: "",
				},
			},
			education_options: [
				{ text: this.$t("register.selectOne"), value: null },

				{ value: "0", text: this.$t("register.educations.illiterate") },
				{ value: "1", text: this.$t("register.educations.elementary") },
				{ value: "2", text: this.$t("register.educations.sycle") },
				{ value: "3", text: this.$t("register.educations.diploma") },
				{ value: "4", text: this.$t("register.educations.skilled") },
				{ value: "5", text: this.$t("register.educations.bachelor") },
				{ value: "6", text: this.$t("register.educations.master") },
				{ value: "7", text: this.$t("register.educations.phd") },
				{ value: "8", text: this.$t("register.educations.medical") },
				{ value: "9", text: this.$t("register.educations.clergy") },
			],
			gender_options: [
				{ value: "m", text: this.$t("register.male") },
				{ value: "f", text: this.$t("register.female") },
			],
			marital_status_options: [
				{ value: 0, text: this.$t("register.single") },
				{ value: 1, text: this.$t("register.married") },
			],
			
			editable: true,
		};
	},
	validations: {
		form: {
			first_name: {
				required,
			},
			last_name: {
				required,
			},
			father_name: {
				required,
			},
			gender: {
				required,
			},
			education: {
				required,
			},
			melli_code: {
				required,
				checkMelliCode,
			},
			mobile_number: {
				required,
				minLength: minLength(11),
				maxLength: maxLength(11),
			},

			birth_date: {
				required,
			},
			phone_number: {
				required,
				minLength: minLength(11),
				maxLength: maxLength(11),
			},
			phone_number_description: {
				required,
			},
			marital_status: {
				required,
			},
			family: {
				first_name: { required },
				last_name: { required },
				Type: { required },
				mobile_number: {
					required,
					minLength: minLength(11),
					maxLength: maxLength(11),
				},
				melli_code: {
					required,
					checkMelliCode,
				},
				phone_number: {
					required,
					minLength: minLength(11),
					maxLength: maxLength(11),
				},
				phone_number_description: { required },
			},
		},
	},
	computed: {
		melliCodeInvalid() {
			return "این فیلد را کامل کنید!";
		},
	},
	mounted() {
		console.log("mraital= ",this.form.marital_status)
		console.log("-----------------------------------------" + this.$route.name);
		this.checkRouteName();
	},
	props: ["routeName"],
	watch: {
		routeName: {
			handler: function() {
				this.checkRouteName();
			},
		},
	},
	methods: {
		checkRouteName() {
			if (
				this.routeName == "firstSuretyIdentityInfo" ||
				this.routeName == "SuppliersCustomerEditFirstSuretyIdentityInfo"
			) {
				if (this.routeName == "SuppliersCustomerEditFirstSuretyIdentityInfo") {
					this.isSupplier = true;
					this.isFirstSupplierSurety = true;
				}
				this.$v.$reset();
				this.isRegisterCompleted = true;
				this.isSurety = true;
				if (this.isSuretyRegistered == false) {
					this.form.melli_code = "";
				}
				this.getFirstSurety();
			} else if (
				this.routeName == "secondSuretyIdentityInfo" ||
				this.routeName == "SuppliersCustomerEditSecondSuretyIdentityInfo"
			) {
				if (this.routeName == "SuppliersCustomerEditSecondSuretyIdentityInfo") {
					this.isSupplier = true;
					this.isFirstSupplierSurety = false;
				}
				this.isRegisterCompleted = true;
				if (this.isSuretyRegistered == false) {
					this.form.melli_code = "";
				}

				this.isSurety = true;
				this.getSecondSurety();
			} else if (
				this.routeName == "editIdentityInfo" ||
				this.routeName == "SupplierEditCustomerIdentityInfo"
			) {
				this.isRegisterCompleted = true;
				this.isSurety = false;
				this.isSupplier = false;
				this.isFirstSupplierSurety = false;
				this.melli_code = this.$store.getters.getMelliCode;
				this.mobile_number = this.$store.getters.getMobileNumber;
				this.password = this.$store.getters.getPassword;
				this.getCustomer();
			} else {
				this.isSurety = false;
				this.isSupplier = false;
				this.isFirstSupplierSurety = false;
				this.isRegisterCompleted = false;
				this.melli_code = this.$store.getters.getCustomer.melli_code;
				(this.mobile_number = this.$store.getters.getCustomer.mobile_number),
					(this.password = this.$store.getters.getCustomer.password);
				this.supplierCustomerId = localStorage.getItem("SupplierCustomerId");
				if (this.supplierCustomerId != 1 || !this.supplierCustomerId) {
					if (localStorage.getItem("customer_token")) {
						this.getCustomer();
					}
				}
			}
		},
		onSubmit() {
			if (!this.isSurety) {
				let currentCustomer = JSON.parse(localStorage.getItem("customer"));
				this.form.melli_code = currentCustomer.melli_code;
				this.form.mobile_number = currentCustomer.mobile_number;
				this.form.password = currentCustomer.password;
			}

			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				if (this.isSurety) {
					this.form.password = this.form.mobile_number;
					if (!this.suretyHaveAlreadyRegistered) {
						// eslint-disable-line no-mixed-spaces-and-tabs
						// eslint-disable-line no-mixed-spaces-and-tabs

						this.$store
							.dispatch("createFirstSurety", this.form)
							.then((response) => {
								console.log(response);
								load.hide();
								this.$noty.success(this.$t("alert.successSuretyCreated"));
							})
							.catch((err) => {
								console.log(err);
								if (err.body.detail) {
									this.$noty.error(err.body.detail);
								}

								load.hide();
							});
					} else {
						this.updateCustomer();
						load.hide();
					}
				} else {
					this.$store
						.dispatch("creatCustomer", this.form)
						.then((response) => {
							console.log(response);
							load.hide();
							//if(this.isSurety)
							//{
							// localStorage.setItem("SupplierCustomerId",response.body.id)
							// localStorage.setItem("SupplierCustomerMelliCode",this.$store.getters.getCustomer.melli_code)
							//}

							if (!localStorage.getItem("SupplierCustomerId")) {
								this.$store.dispatch("login", this.form).then(() => {
									this.$router.push({ name: "registerPage" });
								});
							} else {
								localStorage.setItem("SupplierCustomerId", response.body.id);
								this.$router.push({ name: "registerPage" });
							}
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.error);
							load.hide();
						});
				}
			}
		},

		getCustomer() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getCustomer")
				.then((response) => {
					console.log(response);
					load.hide();
					this.form = response.body;
					this.setFormFamilyNull();
					this.edit = true;
				})
				.catch((err) => {
					console.log(err);
					this.$noty.error(err.body.error);
					load.hide();
					this.edit = false;
				});
		},
		getFirstSurety() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getFirstSurety")
				.then((response) => {
					if (JSON.stringify(response.body) != "{}") {
						console.log(response);
						load.hide();
						this.form = response.body;
						this.edit = true;
						this.isSuretyRegistered = true;
						if (this.isSupplier && this.isFirstSupplierSurety) {
							localStorage.removeItem("suppliersCustomerSecondSuretyID");
							localStorage.setItem(
								"suppliersCustomerFirstSuretyID",
								response.body.id,
							);
							localStorage.setItem("supplierFirstSuretyId", response.body.id);
						}
						this.setFormFamilyNull();
					} else {
						this.setFormNull();
						load.hide();
					}
				})
				.catch((err) => {
					if (err.status == 404) {
						if (this.isSupplier && this.isFirstSupplierSurety) {
							localStorage.removeItem("suppliersCustomerFirstSuretyID");
						}
						this.$noty.error(this.$t("alert.suretyIsNotRegistered"));
						//this.setFormNull()
					} else {
						this.$noty.error(err.body.error);
					}
					console.log(err);

					load.hide();
					this.edit = false;
				});
		},
		getSecondSurety() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getSecondSurety")
				.then((response) => {
					if (JSON.stringify(response.body) != "{}") {
						console.log(response);
						load.hide();
						this.form = response.body;
						this.edit = true;
						this.isSuretyRegistered = true;
						if (this.isSupplier && !this.isFirstSupplierSurety) {
							localStorage.setItem(
								"suppliersCustomerSecondSuretyID",
								response.body.id,
							);
							localStorage.removeItem("suppliersCustomerFirstSuretyID");
							localStorage.setItem("supplierSecondSuretyId", response.body.id);
						}
						this.setFormFamilyNull();
					} else {
						load.hide();
					}
				})
				.catch((err) => {
					this.isSuretyRegistered = false;
					this.form.melli_code = "";
					if (err.status == 404) {
						this.$noty.error(this.$t("alert.suretyIsNotRegistered"));
					} else {
						this.$noty.error(err.body.error);
					}
					//this.checkRouteName()
					console.log(err);

					load.hide();
					this.edit = false;
				});
		},
		updateCustomer() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);

				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				let form = {
					first_name: this.form.first_name,
					last_name: this.form.last_name,
					father_name: this.form.father_name,
					gender: this.form.gender,
					education: this.form.education,
					birth_date: this.form.birth_date,
					phone_number: this.form.phone_number,
					melli_code: this.form.melli_code,
					mobile_number: this.form.mobile_number,
					phone_number_description: this.form.phone_number_description,
					marital_status: this.form.marital_status,
					family: {
						first_name: this.form.family.first_name,
						last_name: this.form.family.last_name,
						Type: this.form.family.Type,
						mobile_number: this.form.family.mobile_number,
						melli_code: this.form.family.melli_code,
						phone_number: this.form.family.phone_number,
						phone_number_description: this.form.family.phone_number_description,
					},
				};
				console.log(form);
				if (this.isSurety) {
					this.$store
						.dispatch("updateSurety", form)
						.then((response) => {
							console.log(response);
							load.hide();
							this.$noty.success(this.$t("alert.successUpdated"));
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.error);
							load.hide();
						});
				} else {
					this.$store
						.dispatch("updateCustomer", form)
						.then((response) => {
							console.log(response);
							load.hide();
							this.$noty.success(this.$t("alert.successUpdated"));
							if (!this.isRegisterCompleted) {
								this.$router.push({ name: "registerPage" });
							}
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.error);
							load.hide();
						});
				}
			}
		},
		setFormNull() {
			this.form = {
				first_name: "",
				last_name: "",
				father_name: "",
				gender: "",
				password: "",
				education: "",
				birth_date: "",
				phone_number: "",
				mobile_number: "",
				phone_number_description: "",
				melli_code: "",
				marital_status: "",
				family: null,
			};
			this.setFormFamilyNull();
		},
		setFormFamilyNull() {
			if (this.form.family == null) {
				this.form.family = {
					first_name: "",
					last_name: "",
					Type: "",
					mobile_number: "",
					melli_code: "",
					phone_number: "",
					phone_number_description: "",
				};

				console.log(JSON.stringify(this.form));
			}
		},
		sendMelliCode() {
			this.$v.$touch();
			if (this.$v.form.melli_code.$invalid) {
				console.log(this.$v.form);
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				this.$store
					.dispatch("sendMelliCode", this.form.melli_code)
					.then((response) => {
						this.form.melli_code = localStorage.getItem("suretyMelliCode");
						console.log(response);
						this.suretyHaveAlreadyRegistered = true;
						this.isSurety = true;
						this.isSuretyRegistered = true;
						this.form = response.body;
						this.setFormFamilyNull();
					})
					.catch((err) => {
						if (err.status == 404) {
							this.isSuretyRegistered = true;
							this.$noty.success(this.$t("alert.suretyMelliCodeNotFound"));
							this.setFormNull();
							this.$v.$reset();
							this.form.melli_code = localStorage.getItem("suretyMelliCode");
							this.edit = false;
						} else {
							console.log("err:" + JSON.stringify(err));
							this.$noty.error(err.body.Error);
						}
					});
			}
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},

		validateStateFamily(name) {
			const { $dirty, $error } = this.$v.form.family[name];
			return $dirty ? !$error : null;
		},
	},
	components: {
		datePicker: VuePersianDatetimePicker,
	},
};
</script>
<style>
.is-valid,
.is-invalid {
	background-position: center right 2%;
}
input.is-valid,
input.is-invalid {
	padding-right: 18% !important;
}
input[type="password"],
input#melli_code,
input#mobile_number,
input#repassword {
	padding-right: 5% !important;
}
select.is-valid {
	padding-right: 30%;
}
@media screen and (max-width: 500px) {
	select.is-valid {
		padding-right: 20%;
	}
}
</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css"></style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>
